module.exports = __webpack_public_path__ + "static/mapkins-machine-a070fec1f84da70bbdc574d2e3d14b3e.jpg";